import React, { useContext } from "react";
import { Row, Col, Typography } from "antd";
import BillContext from "../../reducer";
import { _ } from "../../../../../utils";

const { Text } = Typography;

const HeaderDetail = () => {
  const {
    state: { billHeader, billDetail },
  } = useContext(BillContext);

  return (
    <Row gutter={[8, 8]}>
      {_.map(billHeader, (n, i) => {
       
        if (n.value === "rp") {

          if (billDetail.saletype === "redeem") {
            return null;
          }

          if (billDetail.rp_point_amount > 0) {
            return (
              <Col span={6} key={`header-${i}`}>
                <Text strong>
                  {billDetail.rp_point_use} RP แลกค่าจัดส่ง
                </Text>
                <Text strong> ฿{billDetail.rp_point_amount}</Text>
              </Col>
            );
          }

          return null;
        }

        return (
          <Col span={6} key={`header-${i}`}>
            <Text strong>{n.title} : </Text>
            <Text
              className={
                n.value === "clarify_text"
                  ? billDetail[n.value] === "แจงแล้ว"
                    ? "text-nn"
                    : billDetail[n.value] === "ยังไม่แจง"
                    ? "text-pv"
                    : ""
                  : ""
              }
            >
              {billDetail[n.value]}
            </Text>
          </Col>
        );
        
      })}
    </Row>
  );
};

export default HeaderDetail;
